/**
 * assets/weinserien.js
 * No 7 Augsburg – Weinserie-Landingpage
 * Analog zur Zigarrenserie:
 *   - Mengenrabatt aus Metafeld "6;5|12;8,6" -> Staffelpreiszeilen rendern
 *   - Grundpreisberechnung (Pflicht fuer Wein: EUR/l)
 *   - Cart-Drawer via fetch('/cart') + .sidebar__body innerHTML
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     Hilfsfunktionen
  ───────────────────────────────────────────────────────────── */

  /** Cent-Betrag zu deutschem Preisstring formatieren */
  window.n7wsFormatMoney = function (cents) {
    var eur = (cents / 100).toFixed(2).replace('.', ',');
    return eur + '\u00a0\u20ac';
  };

  /** Grundpreis berechnen und formatieren (EUR pro 1 l) */
  window.n7wsFormatBasePrice = function (cents, volLiters) {
    if (!volLiters || volLiters <= 0) return '';
    var perLiter = (cents / 100) / volLiters;
    var formatted = perLiter.toFixed(2).replace('.', ',');
    return formatted + '\u00a0\u20ac\u00a0/\u00a01\u00a0l';
  };

  /**
   * Staffelpreisstufen aus Metafeld-String parsen
   * Akzeptiert beide Trennzeichen-Varianten:
   *   "6;5|12;8,6"  (Pipe-getrennt)
   *   "6;5,12;8,6"  (Komma-getrennt, Dezimalkomma in 8,6 bleibt erhalten)
   * Rueckgabe: [{qty:6, pct:5}, {qty:12, pct:8.6}]
   *
   * Trick: Ein Komma ist nur dann Stufentrenner, wenn ihm "Ziffern;" folgt
   * (= Beginn einer neuen qty;pct-Stufe). Ein Dezimalkomma wie in "8,6" wird
   * nie von ";" gefolgt und bleibt daher unangetastet. Wir wandeln solche
   * Trenn-Kommas in Pipes um und splitten dann sauber.
   */
  window.n7wsParseTiers = function (raw) {
    if (!raw) return [];
    var str = String(raw).trim();
    str = str.replace(/,(\d+\s*;)/g, '|$1');
    var tiers = [];
    var parts = str.split('|');
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i].trim();
      if (!seg) continue;
      var kv = seg.split(';');
      if (kv.length < 2) continue;
      var qty = parseInt(kv[0], 10);
      var pct = parseFloat(kv[1].replace(',', '.'));
      if (!isNaN(qty) && !isNaN(pct) && qty > 0 && pct > 0) {
        tiers.push({ qty: qty, pct: pct });
      }
    }
    return tiers;
  };

  /* ─────────────────────────────────────────────────────────────
     Staffelpreise + Grundpreise in jede Zeile rendern
  ───────────────────────────────────────────────────────────── */
  window.n7wsRenderPriceBlocks = function () {
    var rows = document.querySelectorAll('.n7ws-row');
    if (!rows.length) return;

    for (var ri = 0; ri < rows.length; ri++) {
      var row        = rows[ri];
      var priceCents = parseInt(row.getAttribute('data-price') || '0', 10);
      var vol        = parseFloat(row.getAttribute('data-vol') || '0');
      var rabattRaw  = row.getAttribute('data-rabatt') || '';
      var prodId     = row.getAttribute('data-product-id') || '';

      var buyCol = document.getElementById('n7ws-buy-' + prodId);
      if (!buyCol) continue;

      /* Grundpreis der Einzelflasche in die Basiszeile */
      var baseEl = buyCol.querySelector('.n7ws-tier-row--single .n7ws-tier-base');
      if (baseEl && vol > 0) {
        baseEl.textContent = window.n7wsFormatBasePrice(priceCents, vol);
      }

      /* Vorhandene Staffelzeilen entfernen (Reload-Schutz) */
      var existing = buyCol.querySelectorAll('.n7ws-tier-row--staffel');
      for (var ei = 0; ei < existing.length; ei++) {
        existing[ei].parentNode.removeChild(existing[ei]);
      }

      var tiers = window.n7wsParseTiers(rabattRaw);
      if (!tiers.length) continue;

      /* Anker zum Einfuegen: der Aktions-Container (.n7ws-buy-actions) ist
         direktes Kind von buyCol. Bei ausverkauft gibt es nur den Button. */
      var anchor = buyCol.querySelector('.n7ws-buy-actions');
      if (!anchor) {
        anchor = buyCol.querySelector('.n7ws-add-cart-btn');
      }

      for (var ti = 0; ti < tiers.length; ti++) {
        var tier            = tiers[ti];
        var discountedCents = Math.round(priceCents * (1 - tier.pct / 100));
        var isBest          = (ti === tiers.length - 1);

        var tr = document.createElement('div');
        tr.className = 'n7ws-tier-row n7ws-tier-row--staffel' + (isBest ? ' n7ws-tier-row--best' : '');

        /* Label-Spalte: "ab X Flaschen" + Rabatt-Badge darunter */
        var labelWrap = document.createElement('span');
        labelWrap.className = 'n7ws-tier-label';
        labelWrap.appendChild(document.createTextNode('ab ' + tier.qty + ' Flaschen'));
        var discBadge = document.createElement('span');
        discBadge.className = 'n7ws-tier-discount';
        discBadge.textContent = '\u2212' + String(tier.pct).replace('.', ',') + '\u00a0%';
        labelWrap.appendChild(discBadge);

        /* Preis-Spalte: Stückpreis + durchgestrichener Originalpreis + Grundpreis + Gesamt */
        var priceWrap = document.createElement('span');
        priceWrap.className = 'n7ws-tier-price-block';

        var priceLine = document.createElement('span');
        priceLine.className = 'n7ws-tier-price';
        priceLine.appendChild(document.createTextNode(window.n7wsFormatMoney(discountedCents) + ' / Fl.'));
        var orig = document.createElement('span');
        orig.className = 'n7ws-tier-orig';
        orig.textContent = window.n7wsFormatMoney(priceCents);
        priceLine.appendChild(orig);
        priceWrap.appendChild(priceLine);

        var baseLine = document.createElement('span');
        baseLine.className = 'n7ws-tier-base';
        if (vol > 0) {
          baseLine.textContent = window.n7wsFormatBasePrice(discountedCents, vol);
        }
        priceWrap.appendChild(baseLine);

        tr.appendChild(labelWrap);
        tr.appendChild(priceWrap);

        if (anchor && anchor.parentNode === buyCol) {
          buyCol.insertBefore(tr, anchor);
        } else {
          buyCol.appendChild(tr);
        }
      }
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Aktuell gewaehlte Menge einer Zeile ermitteln
  ───────────────────────────────────────────────────────────── */
  window.n7wsGetQty = function (prodId) {
    var input = document.getElementById('n7ws-qty-' + prodId);
    if (!input) return 1;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    return q;
  };

  /* ─────────────────────────────────────────────────────────────
     Staffelzeile passend zur gewaehlten Menge hervorheben
     (welche Schwelle ist erreicht?)
  ───────────────────────────────────────────────────────────── */
  window.n7wsHighlightTier = function (prodId) {
    var buyCol = document.getElementById('n7ws-buy-' + prodId);
    if (!buyCol) return;
    var row = buyCol.closest('.n7ws-row');
    if (!row) return;

    var qty   = window.n7wsGetQty(prodId);
    var tiers = window.n7wsParseTiers(row.getAttribute('data-rabatt') || '');

    /* aktive Schwelle bestimmen: hoechste Stufe, deren qty <= gewaehlte Menge */
    var activeIdx = -1;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty) activeIdx = i;
    }

    /* alle Staffelzeilen zuruecksetzen, aktive markieren */
    var staffelRows = buyCol.querySelectorAll('.n7ws-tier-row--staffel');
    for (var s = 0; s < staffelRows.length; s++) {
      if (s === activeIdx) {
        staffelRows[s].classList.add('n7ws-tier-row--active');
      } else {
        staffelRows[s].classList.remove('n7ws-tier-row--active');
      }
    }

    /* Einzelflaschen-Zeile aktiv, wenn keine Schwelle erreicht */
    var singleRow = buyCol.querySelector('.n7ws-tier-row--single');
    if (singleRow) {
      if (activeIdx === -1) {
        singleRow.classList.add('n7ws-tier-row--active');
      } else {
        singleRow.classList.remove('n7ws-tier-row--active');
      }
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Cart Drawer aktualisieren und oeffnen
     Inhalt via fetch('/cart') aktualisieren, dann den echten Cart-Trigger
     des Themes klicken (aria-controls="site-cart-sidebar") - das oeffnet
     zuverlaessig den Warenkorb-Drawer (nicht das Menue).
  ───────────────────────────────────────────────────────────── */
  window.n7wsOpenCartDrawer = function () {
    /* Sichtbaren Cart-Trigger im Header finden und klicken */
    var triggers = document.querySelectorAll('[aria-controls="site-cart-sidebar"]');
    var visibleTrigger = null;
    for (var i = 0; i < triggers.length; i++) {
      var rect = triggers[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) { visibleTrigger = triggers[i]; break; }
    }
    if (visibleTrigger) {
      visibleTrigger.click();
      return true;
    }
    /* Fallback: direkte show()-Methode */
    var sidebarEl = document.querySelector('sidebar-drawer#site-cart-sidebar');
    if (sidebarEl && typeof sidebarEl.show === 'function') {
      sidebarEl.show();
      return true;
    }
    return false;
  };

  window.n7wsUpdateCartDrawer = function () {
    return fetch('/cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser   = new DOMParser();
        var doc      = parser.parseFromString(html, 'text/html');

        /* WICHTIG: gezielt den CART-Sidebar aus dem gefetchten HTML lesen.
           Die /cart-Seite enthaelt mehrere .sidebar__body (Menue + Warenkorb).
           Ein blindes doc.querySelector('.sidebar__body') wuerde das Menue treffen. */
        var fetchedCart = doc.querySelector('sidebar-drawer#site-cart-sidebar');
        var newBody  = fetchedCart ? fetchedCart.querySelector('.sidebar__body') : null;
        var newTitle = fetchedCart ? fetchedCart.querySelector('.sidebar__title') : null;

        var sidebarEl = document.querySelector('sidebar-drawer#site-cart-sidebar');

        if (sidebarEl) {
          var bodyEl  = sidebarEl.querySelector('.sidebar__body');
          var titleEl = sidebarEl.querySelector('.sidebar__title');
          if (bodyEl && newBody) {
            bodyEl.innerHTML = newBody.innerHTML;
          }
          if (titleEl && newTitle) {
            titleEl.innerHTML = newTitle.innerHTML;
          }
          var cartForm = sidebarEl.querySelector('cart-form');
          if (cartForm && typeof cartForm.ajaxifyCartItems === 'function') {
            cartForm.ajaxifyCartItems();
          }
        }

        /* Drawer ueber den echten Theme-Trigger oeffnen */
        window.n7wsOpenCartDrawer();
      })
      .catch(function (err) {
        console.warn('[n7ws] Cart-Drawer-Fehler:', err);
      });
  };

  /* ─────────────────────────────────────────────────────────────
     Event-Handler: Mengen-Buttons, Add-to-Cart, Mehr-lesen
     Ein delegierter Listener fuer die ganze Seite.
  ───────────────────────────────────────────────────────────── */
  window.n7wsBindEvents = function () {
    var page = document.getElementById('n7-weinserien-page');
    if (!page || page.getAttribute('data-n7ws-bound') === '1') return;
    page.setAttribute('data-n7ws-bound', '1');

    /* Klicks: Mengen +/-, Add-to-Cart, Mehr-lesen */
    page.addEventListener('click', function (e) {

      /* Mengen-Buttons */
      var qtyBtn = e.target.closest('.n7ws-qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var wrap  = qtyBtn.closest('.n7ws-qty-wrap');
        var input = wrap ? wrap.querySelector('.n7ws-qty-input') : null;
        if (!input) return;
        var cur = parseInt(input.value, 10);
        if (isNaN(cur) || cur < 1) cur = 1;
        var action = qtyBtn.getAttribute('data-qty-action');
        if (action === 'plus') cur += 1;
        if (action === 'minus' && cur > 1) cur -= 1;
        input.value = cur;
        var rowEl = qtyBtn.closest('.n7ws-row');
        if (rowEl) window.n7wsHighlightTier(rowEl.getAttribute('data-product-id'));
        return;
      }

      /* Mehr lesen / Weniger */
      var rm = e.target.closest('.n7ws-intro__readmore');
      if (rm) {
        e.preventDefault();
        var desc = document.getElementById('n7ws-intro-desc');
        if (!desc) return;
        var expanded = desc.classList.toggle('n7ws-intro__desc--expanded');
        rm.innerHTML = expanded ? 'Weniger anzeigen \u2039' : 'Mehr lesen \u203a';
        return;
      }

      /* In den Warenkorb */
      var btn = e.target.closest('.n7ws-add-cart-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      var prodId    = btn.getAttribute('data-product-id');
      if (!variantId) return;

      var qty = window.n7wsGetQty(prodId);

      btn.classList.add('n7ws-loading');
      var origLabel = btn.textContent;
      btn.textContent = 'Wird hinzugef\u00fcgt\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (errData) {
              throw new Error(errData.description || ('cart/add.js: ' + r.status));
            });
          }
          return r.json();
        })
        .then(function () {
          btn.classList.remove('n7ws-loading');
          btn.classList.add('n7ws-added');
          btn.textContent = 'Hinzugef\u00fcgt \u2714';

          window.n7wsUpdateCartDrawer();

          setTimeout(function () {
            btn.classList.remove('n7ws-added');
            btn.textContent = 'In den Warenkorb';
          }, 2200);
        })
        .catch(function (err) {
          console.warn('[n7ws] cart/add.js Fehler:', err);
          btn.classList.remove('n7ws-loading');
          btn.textContent = origLabel || 'In den Warenkorb';
        });
    });

    /* Direkte Eingabe ins Mengenfeld -> Tier-Hervorhebung aktualisieren */
    page.addEventListener('input', function (e) {
      var input = e.target.closest('.n7ws-qty-input');
      if (!input) return;
      var rowEl = input.closest('.n7ws-row');
      if (rowEl) window.n7wsHighlightTier(rowEl.getAttribute('data-product-id'));
    });
  };

  /* ─────────────────────────────────────────────────────────────
     "Mehr lesen" nur zeigen wenn Text lang genug ist
  ───────────────────────────────────────────────────────────── */
  window.n7wsSetupReadmore = function () {
    var desc = document.getElementById('n7ws-intro-desc');
    var btn  = document.getElementById('n7ws-readmore');
    if (!desc || !btn) return;
    /* Wenn der Inhalt nicht hoeher ist als die zusammengeklappte Box: Button ausblenden */
    if (desc.scrollHeight <= desc.clientHeight + 4) {
      btn.style.display = 'none';
      desc.classList.add('n7ws-intro__desc--expanded');
    } else {
      btn.style.display = '';
    }
  };

  /* ─────────────────────────────────────────────────────────────
     Init
  ───────────────────────────────────────────────────────────── */
  window.n7wsInit = function () {
    if (!document.getElementById('n7-weinserien-page')) return;
    window.n7wsRenderPriceBlocks();
    window.n7wsBindEvents();
    window.n7wsSetupReadmore();
    /* initiale Tier-Hervorhebung pro Zeile */
    var rows = document.querySelectorAll('.n7ws-row');
    for (var i = 0; i < rows.length; i++) {
      window.n7wsHighlightTier(rows[i].getAttribute('data-product-id'));
    }
  };

  /* Drei Lifecycle-Hooks analog zur Zigarrenserie */
  window.n7wsInit();

  document.addEventListener('DOMContentLoaded', function () {
    window.n7wsInit();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#n7-weinserien-page')) {
      window.n7wsInit();
    }
  });

}());